import { BasicTable, MASK_MONEY, MASK_NUMBER } from '../theme/Component/BasicTable';
import { Singleton } from '../../core/services/Singleton';
import { ContractService } from '../../core/services/ContractService';
import { useState, useEffect } from 'react';
import { ModalConfirm } from '../theme/Component/ModalConfirm';
import { Modal } from '../theme/Component/Modal';
import { ListMenu } from "../theme/Component/ListMenu";
import { ReclasificarItem } from "./ReclasificarItem";
import { AdquisitionItemAnalyst } from "./AdquisitionItemAnalyst";
import { AdquisitionItemForm } from "./AdquisitionItemForm";
import { AdquisitionItemBudgetID } from "./AdquisitionItemBudgetID";
import { useDashboardStore } from "../pages/hooks/useDashboardStore";
import usePaginator from '../theme/Component/usePaginator';
import { ExportXLSL } from '../theme/Component/ExportXLSX';
import { DropDown } from '../theme/Component/DropDown';
import { ESTATE_ADQUISITIONITEM } from '../Constants';
import AutoChart from '../../core/graph/AutoChart';
import useModal, { MODAL_XL } from '../theme/Component/hooks/useModal';
import { _single } from '../../core/services/dataBean/EntityCatalog';
import { BasicButton } from '../theme/Component/BasicButton';

interface Props {
    idAdquisitionPlan: number;
    _phaseState: number;
    rol?: number;
}
export const AdquisitionItemCatalog = ({ idAdquisitionPlan, _phaseState, rol }: Props) => {

// lista general de items vista desde el plan de compras

    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service = new ContractService();
    const [lista, setLista] = useState([]);
    const [listaExport, setListaExport] = useState([]);
    const [token, setToken] = useState<number>(0);
    const [beanItem, setBeanItem] = useState<any>({});
    const [permisos, setPermisos] = useState([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalAnalyst, setModalAnalyst] = useState<any>({ name: 'Analista', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalConfirm1, setModalConfirm1] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalItem, setModalItem] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalArticulo, setModalArticulo] = useState<any>({ name: 'Articulos', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalRubro, setModalRubro] = useState<any>({ name: 'Rubros', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalCSV, setModalCSV] = useState<any>({ name: 'Reporte', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-md' });
    const modalGraph = useModal("Necesidades", MODAL_XL);
    const [idAdquisitionItem, setIdAdquisitionItem] = useState<number>(0);

    const paginador = usePaginator();

    const idBean = 'IDAdquisitionItem';
    const listaEstados = ESTATE_ADQUISITIONITEM;

    const head = [
        { title: 'IDPAA', property: idBean, mask: MASK_NUMBER },
        { title: 'Código', property: 'CodeItem' },
        { title: 'Necesidad', property: 'Description' },
        { title: 'Justificación', property: 'Justification', visible: false },
        { title: 'Proyecto', property: 'ProjectName', visible: false },
        { title: 'Rubro', property: 'IDLnBudgetIDNameList' },
        { title: 'Valor total estimado', property: 'TotalValue', mask: MASK_MONEY },
        { title: 'Valor total Bien/servicio', property: 'TotalArticle', mask: MASK_MONEY, visible: false },
        { title: 'PI', property: 'PITotal', mask: MASK_MONEY },
        { title: 'CC', property: 'CCTotal', mask: MASK_MONEY },
        { title: 'PF', property: 'PFTotal', mask: MASK_MONEY },
        { title: 'CDP', property: 'CDPTotal', mask: MASK_MONEY },
        { title: 'RCDP', property: 'RCDPTotal', mask: MASK_MONEY },
        { title: 'Saldo CDP (PF - CDP + RCDP)', property: 'LeftValue', mask: MASK_MONEY, visible: true },
        { title: 'RP', property: 'RPTotal', mask: MASK_MONEY, visible: true },
        { title: 'RRP', property: 'RRPTotal', mask: MASK_MONEY, visible: true },
        { title: 'OB', property: 'OBTotal', mask: MASK_MONEY, visible: true },
        { title: 'Saldo RP (RP - RRP - OB)', property: 'RPSaldo', mask: MASK_MONEY, visible: true },
        { title: 'CE', property: 'CETotal', mask: MASK_MONEY, visible: true },
        { title: 'Modalidad de selección', property: 'ModalityName', visible: true },
        { title: 'Dias Estructuracón', property: 'StructureDays', visible: true, mask: MASK_NUMBER },
        { title: 'Mes', property: 'MonthName', visible: true },
        { title: 'Mes Contrato', property: 'MonthName2', visible: true },
        { title: 'Código Unspsc', property: 'NameUnscp', visible: false },
        { title: 'Iniciativa Estratégica', property: 'NameIniciative', visible: true },
        { title: 'Dependencia Solicitante', property: 'IDLnFunctionalIDName' },
        { title: "Preparador", property: "PreparerName", visible: false },
        { title: "Analista", property: "AccountAnalystName", visible: false },
        { title: "Estado preparación", property: "PreparationStateName" },
    ]


    useEffect(() => {
        getLista();
        return () => {
            paginador.setPage(1);
        }
    }, [])
    useEffect(() => {
        setToken(single.getRandomInt());
    }, [modalArticulo])
    useEffect(() => {
        getLista();
    }, [paginador.page])

    const setRowBean = (bean: any) => {
        setBeanItem(bean);
    }

    const getLista = () => {

        setLoading(true);

        service.getAdquisitionItemCatalog(idAdquisitionPlan, idAdquisitionItem > 0 ? idAdquisitionItem : null, paginador.page, 15).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue.DataBeanProperties.List) {
                    let pag = resp.DataBeanProperties.ObjectValue.DataBeanProperties;
                    paginador.setPages(pag.NumberOfPages);
                    setLista(pag.List);
                }
                setLoading(false);
            }
        );
        setModal({ ...modal, ['view']: false });
    }
    const getListaExport = () => {
        setLoading(true);
        service.getAdquisitionItemCatalog(idAdquisitionPlan, null, null, null).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue.DataBeanProperties.List) {
                    let pag = resp.DataBeanProperties.ObjectValue.DataBeanProperties;
                    setListaExport(pag.List);
                }
                setLoading(false);
            }
        );
    }

    const eliminarItem = () => {

        setLoading(true);
        service.deleteAdquisitionItem(beanItem.IDAdquisitionItem).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp) {
                    getLista();
                }
                single.delete(beanItem[idBean], beanItem);
            }
        );
        setModalConfirm1({ ...modalConfirm1, "view": false });
    }

    const updateItem = () => {

        setModal({ ...modal, ['view']: false });
        setLoading(true);
        service.updateHiringModality({ ...beanItem, IDEmployee: _single.getAccountID() }).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp.DataBeanProperties.ObjectValue) {
                    getLista();
                }
                if (beanItem[idBean]) {
                    single.update(beanItem);
                }
                else {
                    single.create(beanItem);
                }
            }
        );
    }

    const agregarItemList = () => {

        let b = {
            IDAdquisitionPlanFunctionalID: beanItem.IDAdquisitionPlanFunctionalID,
            Description: '',
            EstimatedValue: 0,
            ItemOrder: 1,
            ExecutionMonth: 0,
            EstimatedMonths: 1,
            IDBudgetIDType: 0,
            IDLnBudgetID: 0,
            Justification: '',
            IDFunctionalIDPreparer: 0,
        }

        setBeanItem(b);
        setModalItem({ ...modalItem, ['view']: true });
    }

    const editarMItem = () => {
        let b = beanItem;
        setBeanItem(b);
        setModalItem({ ...modalItem, "view": true });
    }

    const updateMItem = () => {

        service.updateAdquisitionItem(beanItem).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    getLista();
                }
                if (beanItem[idBean]) {
                    single.update(beanItem);
                }
                else {
                    single.create(beanItem);
                }
                setModalItem({ ...modalItem, "view": false });
            }
        )
    }


    let validarDelete = () => {
        let a = false;
        if (
            single.canDelete() &&
            (beanItem.PreparationState === 30 ||
                beanItem.PreparationState === 7 ||
                beanItem.PreparationState == null) &&
            (_phaseState == 0 ||
                _phaseState == 1)) {
            a = true;
        } else {
            a = false;
        }
        return a;
    }

    const listaBotones = () => {

        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: (single.canEdit() && (_phaseState == 0 || _phaseState == 1)), evento: editarMItem },
            { titulo: 'Eliminar', icono: 'ri-eraser-line', visible: validarDelete(), evento: () => { setModalConfirm1({ ...modalConfirm1, ['view']: true }) } },
            { titulo: 'Rubros', icono: 'ri-git-branch-line', visible: true, evento: () => { setModalRubro({ ...modalRubro, "view": true }) } },
            { titulo: 'Reclasificar', icono: 'ri-exchange-line', visible: true, evento: () => { setModal({ ...modal, ['view']: true }); } },
            { titulo: 'Analista Compras', icono: 'ri-exchange-line', visible: single.canEdit(), evento: () => { setModalAnalyst({ ...modalAnalyst, ['view']: true }); } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
        { id: 2, name: 'Reporte', permiso: null, activo: true },
        // { id: 3, name: 'Proyectar PAA', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-6">
                    {single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }
                </div>
                <div className="col-md-3">
                    <label>IDPAA</label>
                    <input type='number' className='form-control' value={idAdquisitionItem}
                        onChange={(e) => setIdAdquisitionItem(parseInt(e.target.value))}></input>
                </div>
                <div className="col-md-3">
                    <BasicButton useMargin icon='ri-search-line' eventClick={() => {
                        getLista()
                    }}>Buscar</BasicButton>
                </div>
            </div>
        )
    }

    const actions = (e: any) => {

        if (e.id === 1) {
            getListaExport();
            setModalCSV({ ...modalCSV, "view": true });
        }
        else if (e.id === 2) {
            getListaExport();
            modalGraph.open();
        }

    }

    return (
        <>

            <div className="row">



                <div className="col-md-12 p-2">

                    <BasicTable headButtons={buttons()} listButtons={listaBotones()} head={head} body={lista} rowSet={setRowBean}
                        pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}
                    ></BasicTable>
                </div>
            </div>
            <div className="row">
                <div className="col">

                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={listaExport} head={head} useIndexAsXLabel={true}
                            xOptions={['ModalityName', 'Rubro', 'ProjectName', 'NameProject', 'IDLnFunctionalIDName', 'Estado', 'Description', 'MonthName', 'MonthName2']}
                            yOptions={['PITotal', 'CCTotal', 'PFTotal', 'CDPTotal', 'RCDPTotal', 'LeftValue', 'RPTotal', 'RRPTotal', 'OBTotal', 'RPSaldo', 'CETotal']} />

                    </Modal>
                    <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                        {beanItem.Name}
                    </ModalConfirm>

                    <Modal modal={modalAnalyst} updateModal={setModalAnalyst}>
                        <AdquisitionItemAnalyst idAdquisitionItem={beanItem.IDAdquisitionItem} updateFather={getLista} />
                    </Modal>

                    {/*Modal de reclasificar item */}
                    <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                        {modal.view &&
                            <ReclasificarItem Item={beanItem} idAdquisitionPlan={idAdquisitionPlan} onChange={getLista} />
                        }
                    </Modal>

                    <ModalConfirm modal={modalConfirm1} updateModal={setModalConfirm1} eventModal={eliminarItem}>
                        {beanItem.Description}
                    </ModalConfirm>

                    {/* rubros de la necesidad  */}
                    <Modal modal={modalRubro} updateModal={setModalRubro} eventModal={() => { }}>
                        <div className="row">
                            <div className="col">
                                {modalRubro.view &&
                                    <AdquisitionItemBudgetID key={beanItem.IDAdquisitionItem} CanModify={beanItem.PreparationState} adquisitionItem={beanItem} iDBudgetIDType={beanItem.IDBudgetIDType} />
                                }
                            </div>
                        </div>
                    </Modal>
                    {/* modal para exportar la lista */}
                    <Modal modal={modalCSV} updateModal={setModalCSV}>
                        <div className="row">
                            <div className="col">
                                {lista.length > 0 &&
                                    <ExportXLSL customName={"Necesidades"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                        single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>
                    {/* adquisition item */}
                    <Modal modal={modalItem} updateModal={setModalItem} eventModal={updateMItem}>
                        <AdquisitionItemForm
                            beanItem={beanItem}
                            setBeanItem={setBeanItem}
                            rol={rol}
                            token={token}

                        />
                    </Modal>
                </div>
            </div>
        </>
    )
}